import { Directive, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive()
export abstract class AbstractComponentMobile implements OnDestroy {
    protected subs: { [key: string]: Subscription } = {};
    protected timeouts: { [key: string]: number } = {};
    protected intervals: { [key: string]: number } = {};

    public abstract tag: string;

    ngOnDestroy() {
        this.destroySubscriptions();
        this.destroyTimeouts();
        this.destroyIntervals();
    }

    ionViewWillLeave() {
        this.destroySubscriptions();
        this.destroyTimeouts();
        this.destroyIntervals();
    }

    protected destroySubscriptions(): void {
        Object.keys(this.subs).forEach(key => {
            const subscription = this.subs[key];
            if (subscription?.unsubscribe) {
                subscription.unsubscribe();
            }
            delete this.subs[key];
        });
    }

    protected destroyTimeouts(): void {
        Object.keys(this.timeouts).forEach(key => {
            const timeout = this.timeouts[key];
            if (timeout) {
                clearTimeout(timeout);
            }
            delete this.timeouts[key];
        });
    }

    protected destroyIntervals(): void {
        Object.keys(this.intervals).forEach(key => {
            const interval = this.intervals[key];
            if (interval) {
                clearInterval(interval);
            }
            delete this.intervals[key];
        });
    }
}
